import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=5b7f189d&scoped=true&"
var script = {}
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=5b7f189d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f189d",
  null
  
)

export default component.exports